/* Company Confidential, Copyright (c) 2017 CRF Box, Ltd. All Rights Reserved. */

import * as topics from './topics';
import * as actionTypes from './actionTypes';
import RequestService from '../service/requestService';
import { RoleServiceInstance } from '../service/roleService';

export const errorFetchingCSV = (errorData) => {
  return {
    type: actionTypes.ERROR_CSV,
    payload: errorData
  };
};

export const fetchingCSV = () => {
  return {
    type: actionTypes.FETCHING_CSV
  };
};

export const receiveCSV = (data) => {
  return {
    type: actionTypes.RECEIVE_CSV,
    payload: data
  };
};

export const clearCSV = () => {
  return {
    type: actionTypes.CLEAR_ERROR_OR_DATA
  };
};

export const publishPermissionMatrix = (matrix) => {
  return {
    type: actionTypes.PUBLISH_PERMISSION_MATRIX,
    payload: matrix
  };
};

export const loadPermissionMatrix = (userId, sponsor) => {
  return (dispatch) => {
    const matrix = RoleServiceInstance.getMatrix([]);
    dispatch(publishPermissionMatrix(matrix));
  };
};

export const fetchReportCSV = (protocolNr, payload) => {
  return function (dispatch) {
    dispatch(fetchingCSV());
    let siteGid = payload.siteGid;
    if (siteGid) {
      return RequestService.getOptInQuestionsReportCSV(protocolNr, payload)
        .then((response) => {
          let blob = new Blob([response.data], { type: 'application/octet-stream' });
          return dispatch(receiveCSV({ objectBlob: { blob, siteGid }, topic: topics.REPORTS }));
        })
        .catch((error) => {
          dispatch(errorFetchingCSV({ error: error, topic: topics.REPORTS }));
        });
    }
    return RequestService.getOptInQuestionsReportAllCSV(protocolNr, payload)
      .then((response) => {
        let blob = new Blob([response.data], { type: 'application/octet-stream' });
        return dispatch(receiveCSV({ objectBlob: { blob, siteGid }, topic: topics.REPORTS }));
      })
      .catch((error) => {
        dispatch(errorFetchingCSV({ error: error, topic: topics.REPORTS }));
      });
  };
};

export const fetchAccessRigthsChangesCSV = (studyGid, payload) => {
  return function (dispatch) {
    dispatch(fetchingCSV());
    return RequestService.getAccessRigthsChangesCSV(studyGid, payload)
      .then((response) => {
        let blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        return dispatch(receiveCSV({ objectBlob: { blob }, topic: topics.ACCESS_RIGHTS }));
      })
      .catch((error) => {
        dispatch(errorFetchingCSV({ error: error, topic: topics.ACCESS_RIGHTS }));
      });
  };
};

export const errorFetchingDelegationLogExportCVS = (errorData) => {
  return {
    type: actionTypes.ERROR_DELEGATIONLOG_EXPORT_CSV,
    payload: errorData
  };
};

export const fetchingDelegationLogExportCVS = () => {
  return {
    type: actionTypes.FETCHING_DELEGATIONLOG_EXPORT_CSV
  };
};

export const receiveDelegationLogExportCVS = (data) => {
  return {
    type: actionTypes.RECEIVE_DELEGATIONLOG_EXPORT_CSV,
    payload: data
  };
};

export const fetchStudyPersonnelReportCVS = (sponsorGid, studyGid) => {
  return function (dispatch) {
    dispatch(fetchingDelegationLogExportCVS());
    return RequestService.getDelegationLogExport(sponsorGid, studyGid)
      .then((response) => {
        let blob = new Blob([response.data], { type: 'application/octet-stream' });
        return dispatch(receiveDelegationLogExportCVS({ objectBlob: { blob } }));
      })
      .catch((error) => {
        dispatch(errorFetchingDelegationLogExportCVS(error));
      });
  };
};
